// // components/AuthBridge.jsx
// import { useEffect } from 'react';
// import { useAuth } from 'react-oidc-context';
// import { registerAuthHandlers } from '../../services/authBridge';

// export default function AuthBridge() {
//     const auth = useAuth();

//     useEffect(() => {
//         registerAuthHandlers({
//             getAccessToken: async () => {
//                 if (!auth.user) throw new Error('NOT_AUTHENTICATED');
//                 const now = Math.floor(Date.now() / 1000);
//                 const exp = auth.user.expires_at ?? 0;

//                 // proactively refresh if expiring within 60s
//                 if (exp - now < 60) {
//                     const u = await auth.signinSilent();
//                     return u.access_token;
//                 }
//                 return auth.user.access_token;
//             },
//             refreshSilently: async () => {
//                 const u = await auth.signinSilent();
//                 return u;
//             },
//             logout: async () => {
//                 try { await auth.removeUser(); } finally { await auth.signoutRedirect(); }
//             }
//         });
//     }, [auth]);

//     return null;
// }

import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { registerAuthHandlers } from '../../services/authBridge';

export default function AuthBridge() {
    const auth = useAuth();

    useEffect(() => {
        registerAuthHandlers({
            getAccessToken: async () => {
                if (!auth.user) throw new Error('NOT_AUTHENTICATED');

                const now = Math.floor(Date.now() / 1000);
                const exp = auth.user.expires_at ?? 0;

                if (exp - now < 60) {
                    sessionStorage.setItem(
                        'post_login_redirect',
                        window.location.pathname + window.location.search
                    );

                    const u = await auth.signinSilent();
                    return u.id_token;
                }

                return auth.user.id_token;
            },

            refreshSilently: async () => {
                sessionStorage.setItem(
                    'post_login_redirect',
                    window.location.pathname + window.location.search
                );

                return await auth.signinSilent();
            },

            logout: async () => {
                try {
                    await auth.removeUser();
                } finally {
                    await auth.signoutRedirect();
                }
            }
        });
    }, [auth]);

    return null;
}
